import HttpService from '../services/http.service';

interface EmailData {
  toEmail: string;
  toName: string;
  templateId: string;
  subject: string;
  templateData: {
    company: string;
    date: string;
  };
  fromEmail: string;
  fromName: string;
}

interface OnboardingEmailData {
  toEmail: string;
  toName: string;
  templateId: string;
  subject: string;
  templateData: {
    company: string;
    date: string;
  };
  fromEmail: string;
  fromName: string;
  onboardingKey: string;
}

/**
 * Función para enviar emails usando MailerSend (Solo para administradores)
 * @param emailData - Datos del email a enviar
 * @returns Promise con la respuesta del servidor
 */
export const sendEmailWithMailerSend = async (emailData: EmailData): Promise<any> => {
  try {
    const authToken = localStorage.getItem('auth_token');
    const userRole = localStorage.getItem('user_role');

    if (!authToken) {
      throw new Error('❌ No hay token de autenticación. Por favor, inicia sesión primero.');
    }

    // Verificar que el usuario sea administrador
    if (userRole !== 'admin' && userRole !== 'Admin') {
      throw new Error('❌ Solo los administradores pueden enviar emails con esta función.');
    }

    // Validar campos requeridos
    if (!emailData.toEmail || !emailData.templateId) {
      throw new Error('❌ Email del destinatario y Template ID son requeridos.');
    }

    const response = await HttpService.post('/api/email/send-template', emailData);
    return response;
  } catch (error: any) {

    if (error?.response?.status === 403) {
      throw new Error('❌ Error 403: Sin permisos. Solo administradores pueden usar esta función.');
    }
    throw error;
  }
};

/**
 * Función para enviar emails de onboarding (Público con clave)
 * @param emailData - Datos del email de onboarding a enviar
 * @returns Promise con la respuesta del servidor
 */
export const sendOnboardingEmail = async (emailData: OnboardingEmailData): Promise<any> => {
  try {
    // Validar campos requeridos
    if (!emailData.toEmail || !emailData.templateId || !emailData.onboardingKey) {
      throw new Error('❌ Email del destinatario, Template ID y clave de onboarding son requeridos.');
    }

    // Validar que la clave de onboarding sea correcta
    if (emailData.onboardingKey !== 'XERVIX_ONBOARDING_2024') {
      throw new Error('❌ Clave de onboarding inválida.');
    }

    const response = await HttpService.post('/api/email/send-onboarding', emailData);
    return response;

  } catch (error: any) {
    if (error?.response?.status === 401) {
      throw new Error('❌ Error 401: Clave de onboarding inválida.');
    } else if (error?.response?.status === 400) {
      throw new Error('❌ Error 400: Datos del email inválidos.');
    }
    throw error;
  }
};

export default sendEmailWithMailerSend;
